import _debounce from 'lodash/debounce';
import _isEqual from 'lodash/isEqual';

function _infiniteScroll (el$, promise, offset, reverse) {
  return _debounce(async () => {
    const prevHeight = el$.scrollHeight;
    const prevScrollTop = el$.scrollTop;
    const distanceFromBottom = el$.scrollHeight - el$.offsetHeight - el$.scrollTop;
    if ((!reverse && distanceFromBottom < offset) || (reverse && el$.scrollTop < offset)) {
      await promise();
      el$.style.setProperty('overflow', 'hidden', 'important');
      if (prevScrollTop === el$.scrollTop) {
        // eslint-disable-next-line no-param-reassign
        el$.scrollTop = reverse ? el$.scrollHeight - prevHeight : prevScrollTop;
      }
      setTimeout(() => {
        el$.style.removeProperty('overflow');
        el$.style.setProperty('overflow', 'auto', 'important');
      }, 100);
    }
  }, 100);
}

function addEvent (el, evt, func) {
  el.addEventListener(evt, func);

  return () => {
    el.removeEventListener(evt, func);
  };
}

function destroy (el) {
  if (el.unbind) {
    el.unbind();
    // eslint-disable-next-line no-param-reassign
    delete el.unbind;
  }
}
function setup (el, { modifiers: { reverse }, value = {}, oldValue }) {
  const { promise = value, offset = 100 } = value;
  if (!promise) { destroy(el); return; }

  if (!_isEqual(value, oldValue)) {
    destroy(el);
    // eslint-disable-next-line no-param-reassign
    el.unbind = addEvent(el, 'scroll', _infiniteScroll(el, promise, offset, reverse));
  }
}

export default {
  bind: setup,
  update: setup,
  unbind: destroy,
};
